import React, { useState, FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api/client';
import './Auth.css';

export default function Register() {
  const [name, setName] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/register', { name, companyName, email, password });
      navigate('/login');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao cadastrar');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-wrap">
      <div className="login-visual">
        <div className="brand">
          <div className="brand-mark">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="10" r="3" /><path d="M12 2a8 8 0 0 0-8 8c0 5.4 8 12 8 12s8-6.6 8-12a8 8 0 0 0-8-8z" /></svg>
          </div>
          <div className="brand-name">Otimiza<span>Rota</span></div>
        </div>
        <div className="login-hero">
          <div className="login-eyebrow"><span className="dot" />Comece agora</div>
          <h1 className="login-h1">Sua operação,<br /><em>organizada.</em></h1>
          <p className="login-lede">Cadastre sua transportadora, adicione depósitos e veículos, e comece a otimizar rotas com restrição de capacidade real em minutos.</p>
        </div>
      </div>

      <div className="login-form-wrap">
        <div className="login-card">
          <h2>Criar conta</h2>
          <p className="sub">Leva menos de um minuto</p>
          {error && <p className="msg-error">{error}</p>}
          <form onSubmit={handleSubmit}>
            <div className="field">
              <label htmlFor="name">Nome</label>
              <input id="name" className="input" type="text" value={name} onChange={e => setName(e.target.value)} required />
            </div>
            <div className="field">
              <label htmlFor="companyName">Empresa</label>
              <input id="companyName" className="input" type="text" placeholder="Nome da transportadora" value={companyName} onChange={e => setCompanyName(e.target.value)} />
            </div>
            <div className="field">
              <label htmlFor="email">Email</label>
              <input id="email" className="input" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            <div className="field">
              <label htmlFor="password">Senha</label>
              <input id="password" className="input" type="password" value={password} onChange={e => setPassword(e.target.value)} minLength={6} required />
            </div>
            <button type="submit" className="btn btn-primary btn-block btn-lg" disabled={loading}>
              {loading ? 'Cadastrando...' : 'Cadastrar'}
            </button>
          </form>
          <p className="login-foot">Já tem conta? <Link to="/login">Entrar</Link></p>
        </div>
      </div>
    </div>
  );
}
